import { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../config';

const usePostData = (entity) => {
  const { url } = config;

  const [loading, setLoading] = useState(false);
  const [res, setRes] = useState();
  const [payload, setPayload] = useState();
  const [error, setError] = useState(null);

  const setErrorFunc = (msg) => {
    if (!msg) return;
    if (typeof msg?.message === 'object') return msg?.message?.[0];
    else return msg?.message;
  };

  useEffect(() => {
    if (entity) {
      postData(entity, {});
    }
  }, [entity]);

  const postData = async (entity, payload, method = 'post') => {
    setError(null);
    axios[method](`${url}api/${entity}`, payload, { withCredentials: true })
      .then((res) => {
        setRes(res?.data);
        if (payload) setPayload(payload);
      })
      .catch((err) => {
        setError({
          apiError:
            setErrorFunc(err?.response?.data?.message) || 'ארעה שגיאה, נסה שוב'
        });
        console.log('error save data: ', err.response);
      });
    setLoading(false);
  };

  return {
    res,
    payload,
    loading,
    error,
    setError,
    postData
  };
};

export default usePostData;
